import MaterialTable from "components/MaterialTable.js"
import Button from "components/CustomButtons/Button.js"
import { Dialog } from "@material-ui/core"
import { useState } from "react"
import React from "react"
import PubSub from "pubsub-js"
import DialogSelector from "./DialogSelector"
import { useSelector } from "react-redux"

export default ({
  data,
  columns,
  noDataTxt,
  hideHeader,
  detailTxt,
  onDetails,
  removeTxt,
  onRemove,
  onAdd,
  addTxt,
  addData,
  addColumn,
  createTxt,
  onCreate,
  onTopRightButton,
  onTopRightButtonFn,
  topRightButtonTxt,
  forceOpenTopRight,
  onTopRightClose,
  search,
  filtering,
  actions = [],
  ...otherProps
}) => {
  const [open, setOpen] = useState(false)
  const [openTopRight, setOpenTopRight] = useState(false)
  if (forceOpenTopRight) {
    forceOpenTopRight(_ => setOpenTopRight(true))
  }
  const canDelete = useSelector(({ reducer: { canDelete } }) => canDelete)
  return (
    <div className='col align-c'>
      {data && data.length > 0 && (
        <MaterialTable
          title=''
          isLoading={!data}
          data={data}
          style={{ width: "100%" }}
          columns={columns}
          actions={[
            ...actions,
            onTopRightButton || onTopRightButtonFn
              ? {
                  icon: props => (
                    <Button
                      color='primary'
                      onClick={_ => {
                        if (onTopRightButtonFn) onTopRightButtonFn()
                        else setOpenTopRight(true)
                      }}>
                      {topRightButtonTxt}
                    </Button>
                  ),
                  isFreeAction: true,
                }
              : undefined,
            onDetails
              ? {
                  icon: "remove_red_eye",
                  tooltip: detailTxt,
                  onClick: (_, rowData) => onDetails(rowData, rowData),
                }
              : undefined,
            onRemove && canDelete
              ? {
                  icon: "clear",
                  tooltip: removeTxt,
                  onClick: (_, rowData) =>
                    PubSub.confirm({
                      title: removeTxt + " ?",
                      subtitle: "Cette action est irreversible.",
                      onAgree: _ => onRemove(rowData.id, rowData),
                    }),
                }
              : undefined,
          ]}
          onRowClick={_ => null}
          options={{
            search,
            toolbar: onTopRightButton || onTopRightButtonFn ? true : false,
            header: hideHeader ? false : true,
            paging: false,
            filtering,
            actionsColumnIndex: -1,
          }}
          {...otherProps}
        />
      )}
      {data.length === 0 && <h3 className='text-c'>{noDataTxt}</h3>}
      <div className='justify-c align-c margin-top'>
        {onAdd && (
          <Button
            style={{ maxWidth: 200 }}
            color='primary'
            variant='contained'
            onClick={_ => setOpen(true)}>
            {addTxt}
          </Button>
        )}
        {onCreate && (
          <Button color='primary' variant='contained' onClick={onCreate}>
            {createTxt}
          </Button>
        )}
      </div>
      {onTopRightButton && (
        <Dialog
          maxWidth={false}
          onClose={_ => {
            if (onTopRightClose) onTopRightClose()
            setOpenTopRight(false)
          }}
          open={openTopRight}>
          <div style={{ padding: 20 }}>
            <h3 className='text-c'>{topRightButtonTxt}</h3>
            {onTopRightButton(_ => setOpenTopRight(false))}
          </div>
        </Dialog>
      )}
      <DialogSelector
        data={(addData || []).filter(c => !data.some(p => p.id === c.id))}
        onClose={_ => setOpen(false)}
        open={open}
        columns={addColumn}
        selectTxt={addTxt}
        onSelect={rowData => onAdd(rowData.id)}
        title={addTxt}
        onCreate={onCreate}
        createTxt={createTxt}
        add
      />
      {data.length <= 0 && (onTopRightButton || onTopRightButtonFn) && (
        <Button
          color='primary'
          onClick={_ => {
            if (onTopRightButtonFn) onTopRightButtonFn()
            else setOpenTopRight(true)
          }}>
          {topRightButtonTxt}
        </Button>
      )}
    </div>
  )
}
